import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import { getSocialMetas } from '#app/utils/seo.ts'

export const meta: MetaFunction = ({ location }) =>
	getSocialMetas({
		title: 'Terms of Service | Sarah Hitchcox Aesthetics',
		description:
			'Terms and conditions for using the Sarah Hitchcox Aesthetics website and booking services.',
		pathname: location.pathname,
	})

export default function TermsOfServiceRoute() {
	return (
		<div className="mx-auto max-w-4xl p-4">
			<h1 className="mb-4 text-center text-2xl font-bold">
				Terms and Conditions
			</h1>
			<div className="h-96 overflow-auto rounded-lg bg-card p-6 shadow-md">
				<h2 className="text-xl font-semibold">1. Introduction</h2>
				<p>
					Welcome to Sarah Hitchcox Aesthetics! These Terms and Conditions
					govern your use of our app and services. By accessing or using the
					app, you agree to be bound by these terms.
				</p>

				<h2 className="mt-4 text-xl font-semibold">2. Eligibility</h2>
				<p>
					You must be at least 18 years of age to use this app. By using our
					app, you represent and warrant that you meet this age requirement.
				</p>

				<h2 className="mt-4 text-xl font-semibold">
					3. Account Registration and Use
				</h2>
				<p>
					To book appointments, users must register an account using a valid
					mobile number for verification purposes. You agree to provide accurate
					and complete information and to keep this information updated.
				</p>

				<h2 className="mt-4 text-xl font-semibold">4. Services Offered</h2>
				<p>
					This app allows users to schedule appointments for medical spa
					services. Specific services available for booking will be listed
					within the app.
				</p>

				<h2 className="mt-4 text-xl font-semibold">
					5. Appointment Booking and Cancellation
				</h2>
				<p>
					Users can book appointments at available times. Please review the date
					and services before confirming your booking.
				</p>

				<h2 className="mt-4 text-xl font-semibold">6. User Conduct</h2>
				<p>
					Users must not misuse the app or engage in any activity that disrupts
					the provision of our services or harms the reputation of our business.
				</p>

				<h2 className="mt-4 text-xl font-semibold">
					7. Intellectual Property Rights
				</h2>
				<p>
					All content on the app, including text, graphics, logos, and software,
					is the property of Sarah Hitchcox Aesthetics and is protected by
					copyright and other intellectual property laws.
				</p>

				<h2 className="mt-4 text-xl font-semibold">8. Privacy Policy</h2>
				<p>
					Your privacy is important to us. Please review our Privacy Policy to
					understand how we collect, use, and share information about users.
				</p>

				<h2 className="mt-4 text-xl font-semibold">
					9. Limitation of Liability
				</h2>
				<p>
					To the extent permitted by law, Sarah Hitchcox Aesthetics shall not be
					liable for any indirect, incidental, special, consequential, or
					punitive damages arising out of or related to your use of the app.
				</p>

				<h2 className="mt-4 text-xl font-semibold">10. Termination</h2>
				<p>
					We may terminate or suspend your account and access to the app if you
					violate any of these terms.
				</p>

				<h2 className="mt-4 text-xl font-semibold">
					11. Changes to Terms and Conditions
				</h2>
				<p>
					We reserve the right to modify these terms at any time. We will notify
					you of any changes by posting the new terms on the app. Your continued
					use of the app after such changes will constitute your consent to the
					modified terms.
				</p>

				<h2 className="mt-4 text-xl font-semibold">12. Governing Law</h2>
				<p>
					These terms shall be governed by and construed in accordance with the
					laws of the State of Tennessee.
				</p>

				<h2 className="mt-4 text-xl font-semibold">13. Contact Information</h2>
				<p>
					If you have any questions about these Terms and Conditions, please
					contact us at{' '}
					<Link
						to="mailto:sarah@hitchcoxaesthetics.com"
						className="text-primary hover:underline"
					>
						sarah@hitchcoxaesthetics.com
					</Link>
					.
				</p>
			</div>
		</div>
	)
}
